module.exports = __webpack_public_path__ + "static/media/solidity-intermediate.bead071a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/solidity-intermediate.png
// module id = 1469
// module chunks = 146